import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ControlsGlyph = /*#__PURE__*/createElement("g", {
  id: "controls"
}, /*#__PURE__*/createElement("path", {
  d: "M62.05 39.17c-1.01 0-1.89.53-2.39 1.33h-7.5c-.73-4.88-4.94-8.65-10.02-8.65s-9.29 3.76-10.02 8.65h-7.77a2.81 2.81 0 00-2.39-1.33c-1.56 0-2.83 1.27-2.83 2.83s1.27 2.83 2.83 2.83c1.01 0 1.89-.53 2.39-1.33h7.77c.73 4.88 4.94 8.65 10.02 8.65s9.29-3.76 10.02-8.65h7.5c.5.8 1.38 1.33 2.39 1.33 1.56 0 2.83-1.27 2.83-2.83s-1.27-2.83-2.83-2.83zm-19.92 9.98c-3.94 0-7.15-3.21-7.15-7.15s3.21-7.15 7.15-7.15 7.15 3.21 7.15 7.15-3.2 7.15-7.15 7.15z"
}), /*#__PURE__*/createElement("path", {
  d: "M42.13 39.17c-1.56 0-2.83 1.27-2.83 2.83s1.27 2.83 2.83 2.83 2.83-1.27 2.83-2.83-1.26-2.83-2.83-2.83z"
}));
const Controls = createSvg({
  name: 'controls',
  path: ControlsGlyph
});

export default Controls;
export { ControlsGlyph };
